import { render, staticRenderFns } from "./messageBoard.vue?vue&type=template&id=6694dfc7&scoped=true"
import script from "./messageBoard.vue?vue&type=script&lang=js"
export * from "./messageBoard.vue?vue&type=script&lang=js"
import style0 from "./messageBoard.vue?vue&type=style&index=0&id=6694dfc7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6694dfc7",
  null
  
)

export default component.exports